/* eslint-disable import/order */
import { SidebarIdGlobalIssuesSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalIssuesSettings.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { globalSettingsLegacyFieldLayoutRoute } from '@jira/router-routes__admin-pages-legacy-field-layout-routes/src/globalSettingsLegacyFieldLayoutRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { LazyLegacyFieldLayoutPage, LazyLegacyFieldLayoutPromise } from './ui/spa/index.tsx';

export const globalSettingsLegacyFieldLayoutRouteEntry: Route = createEntry(
	globalSettingsLegacyFieldLayoutRoute,

	() => ({
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalIssuesSettings,
		},

		resources: [...getNavigationResources(), navigationSidebarGlobalResource],
		// eslint-disable-next-line no-restricted-syntax
		component: LazyLegacyFieldLayoutPage,
		forPaint: [LazyLegacyFieldLayoutPromise],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
